import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
import { Table } from 'antd'
const { WizSpin, WizButton, WizCard, WizModal, WizDataTable } = component_tool
const { WizContainer } = framework_tool
const { Session, getPageData } = utils_tool
import moment from 'moment'

import CounselingHeader from '../../header'

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/integrationCounseling/manager/preAuditProcess/result') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('preAuditResult', record)
        } else {
            record = Session.get('preAuditResult') || {}
        }
    }
    return record
}

class PreAuditResult extends WizContainer {

    componentName = 'PreAuditResult'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        this.state = {
            record
        }
    }

    _componentDidMount() {
        this._list()
    }

    _list = () => {
        const { processContentId } = this.state.record
        this.doAction({
            path: 'counselingProcess/preAuditOrCheckInfo',
            payload: {
                key: 'preAuditResult@' + processContentId,
                apiParams: {
                    processId: processContentId,
                    type: 1
                }
            }
        })
    }

    _downCriteria = (id) => {
        const { processContentId } = this.state.record
        this.doAction({
            path: 'counselingProcess/downCriteria',
            payload: {
                key: 'downCriteria@' + processContentId,
                apiParams: {
                    id
                }
            }
        })
    }

    _onBtn = (type, id, state) => {
        const { record } = this.state
        let path
        switch (type) {
            case 'look':
                path = '/integrationCounseling/manager/preAuditProcess/result/look'
                break
            case 'audit':
                path = '/integrationCounseling/manager/preAuditProcess/result/evaluation'
                break
            case 'send':
                path = '/integrationCounseling/manager/preAuditProcess/result/send'
                break
        }
        this.jumpPage('push', path, { ...record, recordId: id, state })
    }

    _onDownCriteria = (id) => {
        this._downCriteria(id)
    }

    _onConfirm = () => {
        const { processContentId } = this.state.record
        WizModal.confirm({
            title: '注意',
            content: '是否确认进行达标确认操作？',
            onOk: () => {
                this.doAction({
                    path: 'counselingProcess/confirmPreAuditOrCheck',
                    payload: {
                        key: 'confirmPreAuditResult@' + processContentId,
                        apiParams: {
                            processId: processContentId,
                            type: 1
                        }
                    }
                })
            },
            onCancel() {
            }
        })
    }

    propsAndStateOnChange = {
        downCriteria: this._downCriteriaOnChange.bind(this),
        confirm: this._confirmOnChange.bind(this)
    }

    _downCriteriaOnChange(nextProps, nextState) {
        let { code, data } = nextProps.downCriteria
        if (code === 1) {
            let url = data ? getOssFilePath(data) : ''
            url && window.open(url)
            return true
        }
        wizNotice.error('未获取到评估标准文件，请稍后再试')
    }

    _confirmOnChange(nextProps, nextState) {
        if (nextProps.confirm.code === 1) {
            wizNotice.success('操作成功')
            this.jumpPage('goBack')
        } else {
            wizNotice.error(nextProps.confirm.msg)
        }
    }

    render() {
        let { record } = this.state
        let { processContentState } = record
        let { list, counselingProcessLoading } = this.props
        let data = list.data || []
        let columns = [{
            title: '执行内容',
            name: 'processName',
            dataIndex: 'processName',
            tableItem: {}
        }, {
            title: '通知时间',
            name: 'noticeTime',
            dataIndex: 'noticeTime',
            tableItem: {
                render: (v) => v ? moment(v).format('YYYY-MM-DD HH:mm') : ''
            }
        }, {
            title: '签收时间',
            name: 'completeTime',
            dataIndex: 'completeTime',
            tableItem: {
                render: (v) => v ? moment(v).format('YYYY-MM-DD HH:mm') : ''
            }
        }, {
            title: '状态',
            name: 'state',
            dataIndex: 'state',
            tableItem: {
                render: (v) => {
                    switch (v) {
                        case 0:
                            return '待评估'
                        case 1:
                            return '待下发'
                        case 2:
                            return '待签收'
                        case 3:
                            return '已签收'
                        default:
                            return ''
                    }
                }
            }
        }, {
            title: '操作',
            name: 'operation',
            dataIndex: 'operation',
            tableItem: {
                align: 'center',
                width: 300,
                render: (v, r, i) => {
                    let { id, state } = r
                    return (
                        <WizDataTable.Oper maxNum={3}>
                            <WizButton disabled={processContentState === 1} type='link' onClick={() => this._onBtn('audit', id)}>
                                {state !== 0 ? '重新评估' : '评估'}
                            </WizButton>
                            <WizButton type='link' disabled={state === 0} onClick={() => this._onBtn('look', id)}>
                                {'查看'}
                            </WizButton>
                            <WizButton type='link' disabled={processContentState === 1 || state !== 1} onClick={() => this._onBtn('send', id)}>
                                {'下发'}
                            </WizButton>
                            <WizButton type='link' onClick={() => this._onDownCriteria(id)}>
                                {'下载评估标准'}
                            </WizButton>
                        </WizDataTable.Oper>
                    )
                }
            }
        }]

        let tableProps = {
            columns,
            rowKey: 'id',
            dataItems: getPageData({ records: data }),
            pagination: false,
            bordered: true
        }

        return (
            <WizSpin spinning={counselingProcessLoading} >
                <CounselingHeader record={record} />
                <WizCard title='预审核结果'>
                    <WizButton
                        type='primary'
                        style={{ marginBottom: 15, width: 90 }}
                        disabled={processContentState !== 0 || !data[0] || data[0].state !== 3}
                        onClick={() => this._onConfirm()}>
                        {'达标确认'}
                    </WizButton>
                    <WizDataTable {...tableProps} />
                </WizCard>
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { counselingProcess } = state
    const { processContentId } = findParamRecord(ownProps.history)
    const list = modelUtils.getModelEntity(counselingProcess, 'preAuditResult@' + processContentId)
    const downCriteria = modelUtils.getModelEntity(counselingProcess, 'downCriteria@' + processContentId)
    const confirm = modelUtils.getModelEntity(counselingProcess, 'confirmPreAuditResult@' + processContentId)
    const loading = modelUtils.getLoadingState(state, 'counselingProcess')
    return {
        list,
        downCriteria,
        confirm,
        ...loading
    }
}

export default connect(mapStateToProps)(PreAuditResult)

